import React from 'react';
import { func } from 'prop-types';
import classnames from 'classnames';
import Menu, { MenuWrapper, MenuItem } from './../menu';
import TextField from './textfield';

class AutocompletionTextfield extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onKeyDown = this.onKeyDown.bind(this);
    this.getFilteredItems = this.getFilteredItems.bind(this);
    this.onClose = this.onClose.bind(this);
    this.state = { selected: null, open: false };
    this.filteredItems = [];
  }

  componentDidMount() {
    this.input.addEventListener('keydown', this.onKeyDown);
  }

  componentDidUpdate(props) {
    if (this.menu) {
      const { selected } = this.state;

      if (typeof selected === 'number' && selected !== props.selected) {
        const selectedElement = this.menu.querySelector('.autocompletetion-selected-row');

        if (selectedElement) {
          this.menu.scroll(0, selectedElement.offsetTop - (this.menu.clientHeight / 2));
        }
      }
    }
  }

  componentWillUnmount() {
    this.input.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown(event) {
    if (event.which === 40 || event.which === 38) {
      event.preventDefault();

      this.setState((state) => {
        const getStartSelected = direction => Math.sign(direction - 1);
        const direction = Number(event.which === 40 || -(event.which === 38));
        const selected =
          typeof state.selected === 'number'
            ? state.selected + direction
            : getStartSelected(direction);

        return ({
          open: true,
          selected:
            (selected < 0 ? this.filteredItems.length : 0) + (selected % this.filteredItems.length),
        });
      });
    } else if (event.which === 13) {
      this.props.onSelect(this.filteredItems[this.state.selected]);
    } else {
      this.setState({ selected: null });
    }
  }

  onClose() {
    this.setState({
      open: false,
      selected: null,
    });
  }

  getFilteredItems() {
    const { items, value } = this.props;

    return (
      items
        .filter(p => p.indexOf(value) > -1 && p !== value)
        .sort((a, b) => {
          const orderBySubstrPosition = value && (a.indexOf(value) - b.indexOf(value));
          const alphabeticalOrder = (a < b && -1) || (a > b && 1) || 0;

          return orderBySubstrPosition || alphabeticalOrder;
        })
    );
  }

  render() {
    const {
      value, onSelect, ...props
    } = this.props;

    this.filteredItems = this.getFilteredItems();

    return (
      <MenuWrapper
        floating
        wrappedElement={
          <TextField
            inputRef={(input) => {
              this.input = input;
            }}
            type="text"
            value={value}
            onClick={() => this.setState({ open: true })}
            autocomplete="off"
            {...props}
          />
        }
        overlay={false}
        open={this.state.open}
        className="autocompletetion-input-container"
        onClose={this.onClose}
      >
        <Menu
          style={{ maxHeight: '300px' }}
          disableFocus
          menuRef={(menu) => {
            this.menu = menu;
          }}
        >
          {
            this.filteredItems.map((item, index) => (
              <MenuItem
                onClick={() => {
                  this.setState({ selected: index })
                  onSelect(item);
                }}
                key={item}
                className={classnames({
                  'autocompletetion-selected-row': index === this.state.selected,
                })}
              >
                {item}
              </MenuItem>
            ))
          }
        </Menu>
      </MenuWrapper>
    );
  }
}

AutocompletionTextfield.propTypes = {
  onSelect: func,
};

AutocompletionTextfield.defaultProps = {
  onSelect: () => null,
};

export default AutocompletionTextfield;
